import { render, staticRenderFns } from "./wdct.vue?vue&type=template&id=77a40ee2&"
import script from "./wdct.vue?vue&type=script&lang=js&"
export * from "./wdct.vue?vue&type=script&lang=js&"
import style0 from "./wdct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports